import React from 'react'

import Section from '../../../../../../components/Section'
import { Structure } from '../../../../Org/Structure/types'
import { Contract } from '../../../../Contracts/types'

type Props = {
    theme: string
    contract: Contract
    contractGuid: string
    structShortName: string | null
    structShortGuid: string | null
    structList: Structure[]
}

const ContractCardSupplierInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Контрагент">
            <div className="flex flex-col w-full gap-5 mt-2">
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Наименование контрагента
                        </div>
                        <div className="flex flex-col w-full gap-3 items-start justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract?.suppliers
                                ? props.contract?.suppliers.length > 1
                                    ? props.contract?.suppliers.map(
                                          (sup, index) => (
                                              <div key={index}>
                                                  {index +
                                                      1 +
                                                      '. ' +
                                                      sup.supplier_short_name}
                                              </div>
                                          )
                                      )
                                    : props.contract?.suppliers.map(
                                          (sup, index) => (
                                              <div key={index}>
                                                  {sup.supplier_short_name}
                                              </div>
                                          )
                                      )
                                : ''}
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            ИНН
                        </div>
                        <div className="flex flex-col w-full gap-3 items-start justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract?.suppliers
                                ? props.contract?.suppliers.length > 1
                                    ? props.contract?.suppliers.map(
                                          (sup, index) => (
                                              <div key={index}>
                                                  {index +
                                                      1 +
                                                      '. ' +
                                                      sup.supplier_inn}
                                              </div>
                                          )
                                      )
                                    : props.contract?.suppliers.map(
                                          (sup, index) => (
                                              <div key={index}>
                                                  {sup.supplier_inn}
                                              </div>
                                          )
                                      )
                                : ''}
                        </div>
                    </div>
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Юридический адрес
                        </div>
                        <div className="flex flex-col w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract?.suppliers
                                ? props.contract?.suppliers.length > 1
                                    ? props.contract?.suppliers.map(
                                          (sup, index) => (
                                              <div
                                                  key={index}
                                                  className="flex flex-col w-full gap-3 items-start justify-start text-left"
                                              >
                                                  {index +
                                                      1 +
                                                      '. ' +
                                                      `${sup.supplier_address_post_code ? sup.supplier_address_post_code + ', ' : ''}${sup.supplier_address_country_name ? sup.supplier_address_country_name + ', ' : ''}${sup.supplier_address_region_name ? sup.supplier_address_region_name + ', ' : ''}${sup.supplier_address_city ? sup.supplier_address_city + ', ' : ''}${sup.supplier_address_street ? sup.supplier_address_street + ', ' : ''}${sup.supplier_address_house ? sup.supplier_address_house + ', ' : ''}${sup.supplier_address_building ? sup.supplier_address_building + ', ' : ''}${sup.supplier_address_office ? sup.supplier_address_office : ''}`}
                                              </div>
                                          )
                                      )
                                    : props.contract?.suppliers.map(
                                          (sup, index) => (
                                              <div
                                                  key={index}
                                                  className="flex flex-col w-full gap-3 items-center justify-start"
                                              >
                                                  {index +
                                                      `${sup.supplier_address_post_code ? sup.supplier_address_post_code + ', ' : ''}${sup.supplier_address_country_name ? sup.supplier_address_country_name + ', ' : ''}${sup.supplier_address_region_name ? sup.supplier_address_region_name + ', ' : ''}${sup.supplier_address_city ? sup.supplier_address_city + ', ' : ''}${sup.supplier_address_street ? sup.supplier_address_street + ', ' : ''}${sup.supplier_address_house ? sup.supplier_address_house + ', ' : ''}${sup.supplier_address_building ? sup.supplier_address_building + ', ' : ''}${sup.supplier_address_office ? sup.supplier_address_office : ''}`}
                                              </div>
                                          )
                                      )
                                : ''}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default ContractCardSupplierInfo
